import { GetterTree } from "vuex";
import { GenericTableState } from "./types";
import { RootState } from "@/store/types";

export const GenericTableGetters: GetterTree<GenericTableState, RootState> = {
	getModalRow: state => state.GenericTableModalRow
};
